import kebabCase from 'lodash/kebabCase';

interface Meta {
  requiresAuth?: boolean;
  requiresEvent?: boolean;
  public?: boolean;
  onlyWhenLoggedOut?: boolean;
  label?: string;
}

export function trailingSlash(str: string) {
  return str.endsWith('/') ? str : str + '/';
}
export function redirect(redirect: () => string) {
  return { path: '*', redirect };
}

export function route(
  path: string,
  name?: string,
  children?: any[],
  meta?: Meta,
  redirect?: {},
  file?: string
) {
  const folder = (file || `${kebabCase(name)}`).toLowerCase();

  return {
    component: () => import(`@/views/${folder}/Index.vue`),
    name,
    path: trailingSlash(path),
    meta: meta,
    children,
    redirect,
    props: true
  };
}
export function subRoute(
  path: string,
  name: string,
  component: string,
  children?: any[],
  redirect?: {},
  meta?: Meta
) {
  // const folder = (file || `${kebabCase(name)}`).toLowerCase();

  return {
    component: () => import(`@/${component}.vue`),
    name,
    path: trailingSlash(path),
    meta,
    children,
    redirect,
    props: true
  };
}

export function layout(
  path: string,
  name: string,
  children?: any[],
  redirect?: {}
) {
  const folder = kebabCase(name);

  return {
    path,
    component: () => import(`@/layouts/${folder}/Index.vue`),
    props: true,
    children,
    redirect
  };
}

export function root(children: any[]) {
  return [layout('', 'root', children)];
}
